import { useEffect } from "react";
import { LoadingScreen } from "@flat-ui";

interface Props {
  /** The URL to redirect to */
  targetUrl: string;
}

/**
 * Component that immediately redirects users to external pages
 */
export function ExternalRedirect({ targetUrl }: Props): JSX.Element {
  useEffect(() => {
    window.location.href = targetUrl;
  }, [targetUrl]);

  return <LoadingScreen />;
}
